/**
 * Machina Callida Backend REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Prefix for requests to the Zenodo API, indicating the desired metadata scheme.
 */
export type ZenodoMetadataPrefixExtension = 'marc21' | 'oai_datacite';

export const ZenodoMetadataPrefixExtension = {
    Marc21: 'marc21' as ZenodoMetadataPrefixExtension,
    OaiDatacite: 'oai_datacite' as ZenodoMetadataPrefixExtension
};

